(function ($, cookies) {
  'use strict';

  function toggleWebforms(hideClass, showClass) {
    $(hideClass).hide();
    $(showClass).show();
    $(showClass)[0].scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  }

  $(document).ready(() => {
    /**
     * Tours
     */
    $('.node--type-tour .individual-tour').on("click", () => {
      toggleWebforms(".field--name-field-tour-booking-form", ".field--name-field-tour-individual-form");
    });
    $('.node--type-tour .book-now').on("click", () => {
      toggleWebforms(".field--name-field-tour-individual-form", ".field--name-field-tour-booking-form");
    });

    /**
     * Courses
     */
    $('.node--type-course .individual-course').on("click", () => {
      toggleWebforms(".field--name-field-course-booking-form", ".field--name-field-course-individual-form");
    });
    $('.node--type-course .book-now').on("click", () => {
      toggleWebforms( ".field--name-field-course-individual-form", ".field--name-field-course-booking-form");
    });

  });

  $(document).ready(() => {
    if(cookies.get('cookie-agreed') === '2') {
      $("body").addClass('cookie-agreed');
    }
  })
  $('body').on("click", ".setFunctionalConsent", function () {
    cookies.set('cookie-agreed', '2');
    cookies.set('cookie-agreed-version', '1.0.0');
    location.reload();
  });

})(jQuery, window.Cookies);
